export default __webpack_public_path__ + "static/media/ceramic-bead-blasting-icon-dark.9028d7c2.svg";